import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faAngleDown } from '@fortawesome/pro-solid-svg-icons';

import { TASK_STATUSES, TASK_TYPES } from 'helpers/tasks/constants';

import FilterTopbar from 'components/search_page/filter_topbar';
import FilterRow from 'components/search_page/filter_row';

import { delayRetrieveTasks } from './store/actions/search';
import { changeSearchText } from './store/actions/query';


export class MobileFilterTopBar extends React.Component {
  static propTypes = {
    assigneeId: PropTypes.number,
    availableTags: PropTypes.array,
    creatorId: PropTypes.number,
    delayRetrieveTasks: PropTypes.func.isRequired,
    includeUntagged: PropTypes.bool,
    searchText: PropTypes.string.isRequired,
    status: PropTypes.string,
    tagIds: PropTypes.array,
    type: PropTypes.string,
    users: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      imageUrl: PropTypes.string.isRequired
    })).isRequired,
    onChangeSearchText: PropTypes.func.isRequired,
    onDisplayFilters: PropTypes.func.isRequired
  }

  handleChangeSearchText = (e) => {
    const { delayRetrieveTasks, onChangeSearchText } = this.props;

    onChangeSearchText(e.target.value);
    delayRetrieveTasks();
  };

  render() {
    return (
      <div className="visible-xs visible-sm">
        <FilterTopbar>
          {this.renderSearchFilters()}
        </FilterTopbar>
        {this.renderFilterBar()}
      </div>
    );
  }

  renderSearchFilters() {
    const { searchText } = this.props;

    return (
      <FilterRow
        searchPlaceholder="Search by name or company"
        searchText={searchText}
        onSearchChange={this.handleChangeSearchText}
      />
    );
  }

  renderFilterBar() {
    const {
      assigneeId,
      availableTags,
      creatorId,
      includeUntagged,
      status,
      tagIds,
      type,
      users,
      onDisplayFilters
    } = this.props;

    const appliedFilters = [];
    if (type) {
      const selectedTaskType = Object.values(TASK_TYPES).find(option => option.value === type);
      appliedFilters.push(selectedTaskType.label);
    }

    if (status) {
      const selectedStatus = Object.values(TASK_STATUSES).find(option => option.value === status);
      if (selectedStatus) {
        appliedFilters.push(selectedStatus.label);
      }
    }

    if (assigneeId) {
      const selectedAssignee = Object.values(users).find(option => option.id === assigneeId);
      appliedFilters.push(selectedAssignee.name);
    }

    if (creatorId) {
      const selectedCreator = Object.values(users).find(option => option.id === creatorId);
      appliedFilters.push(selectedCreator.name);
    }

    if (includeUntagged) {
      appliedFilters.push('No Tags');
    }

    if (tagIds && tagIds.length > 0) {
      const selectedTags = availableTags.filter(tag => tagIds.includes(tag.value)).map(tag => tag.label);
      appliedFilters.push(`Tags: ${selectedTags.join(', ')}`);
    }

    return (
      <div className="filters-row mobile-filters-row">
        {appliedFilters.length > 0 ?
          <button className="w-100 text-center filters-text" onClick={onDisplayFilters}>
            <div className="filters-count">{appliedFilters.length}</div>
            <strong>Filters:</strong>
            <span className="applied-filters-text">{appliedFilters.join(', ')}</span>
          </button>
          : <button className="mobile-filters-btn" onClick={onDisplayFilters}>
            <FontAwesomeIcon
              className="right-buffer-sm"
              icon={faFilter}
            />
            Filters
            <FontAwesomeIcon
              className="left-buffer-sm"
              icon={faAngleDown}
            />
          </button>
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  assigneeId: state.query.assigneeId,
  availableTags: state.search.tags,
  creatorId: state.query.creatorId,
  currentUser: state.static.currentUser,
  includeUntagged: state.query.includeUntagged,
  status: state.query.status,
  tagIds: state.query.tagIds,
  type: state.query.taskType,
  users: state.static.databaseMembers
});

const mapDispatchToProps = {
  delayRetrieveTasks,
  onChangeSearchText: changeSearchText,
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileFilterTopBar);
